define(function (require) {
    "use strict";

    var LE = require("app");
    var LEConfig = require("assets/config/le-env-conf");
    var template = require("manager-templates/ShiftStatusView.tmpl");
    var RadioButtonList = require("ui/radio-button-list/RadioButtonList");
    var DatePicker = require("ui/datepicker/DatePicker");
    var Button = require("ui/button/Button");
    var Dropdown = require("ui/dropdown/Dropdown");
    var KpContent = require("ui.components/kpContent/kpContent");
    var Loader = require("ui/loader/Loader");
    var SchedulePicker = require("ui.components/schedule-picker/SchedulePicker");
    var SpecialOccasionPicker = require("ui.components/special-occasion-picker/SpecialOccasionPicker");

    var SHIFT_STATUS_METHODS = {
        MANUAL: "manual",
        SCHEDULED: "scheduled"
    };

    var MANUAL_STATUSES = {
        ONLINE: "onHours",
        OFF_HOURS: "offHours"
    };

    var ShiftStatusView = {};

    LE.module("LEManager", function (LEManager, LE, Backbone, Marionette, $, _) {

        ShiftStatusView = Marionette.ItemView.extend({

            template : template,
            className : "shift-status-dialog-container",
            withUIComponents : true,

            ui: {
                reviewLimitationsKp: ".review-limitations-kp",

                shiftStatusMethodsContainer: ".shift-status-methods-container",
                manualConfiguration: ".shift-status-manual-configuration-container",
                scheduledConfiguration: ".shift-status-scheduled-configuration-container",
                scheduledConfigurationAvailable: ".shift-status-scheduled-configuration-container.configuration",
                scheduledConfigurationComingSoon: ".shift-status-scheduled-configuration-container.coming-soon",

                scheduledSchedulePickerComponent: ".shift-status-scheduled-schedule-component",
                scheduledSpecialOccasionPickerComponent: ".shift-status-scheduled-special-occasion-component",
                scheduledScheduleNoSelectionNote: ".shift-status-scheduled-schedule-no-selection",

                manualStatusList: ".shift-status-manual-status-list",
                manualNextShiftConfig: ".shift-status-manual-next-shift-container",
                manualDatePicker: ".shift-status-manual-date-picker",
                manualHoursList: ".shift-status-manual-hours-list",
                manualNextShiftOverlay: ".shift-status-manual-next-shift-overlay",

                manualErrorContainer: ".shift-status-manual-fetch-error-container",
                manualLoadingLabel: ".shift-status-manual-loading-label",
                manualErrorLabel: ".shift-status-manual-error-label",
                manualErrorLinkToVisitors: ".link-to-visitors",

                btnSave: ".button-save",
                btnCancel: ".button-cancel"
            },

            uiComponents: {
                shiftSchedulerLimitationsLink: {
                    type : KpContent,
                    options : {
                        container: "view.ui.reviewLimitationsKp",
                        KPLink: LE.translator.translate("LEManager.manager.shift.status.reviewLimitations.link"),
                        kpID: "shift-scheduler-limitations",
                        showKPIcon: false
                    }
                },
                methodsRadioButtonList: {
                    type: RadioButtonList,
                    options: {
                        el: "view.ui.shiftStatusMethodsContainer",
                        items: [
                            {key: SHIFT_STATUS_METHODS.MANUAL, label: LE.translator.translate("LEManager.manager.shift.status.method.manual")},
                            {key: SHIFT_STATUS_METHODS.SCHEDULED, label: LE.translator.translate("LEManager.manager.shift.status.method.scheduled")},
                        ],
                        allowHtml: false,
                        permutation: RadioButtonList.PERMUTATION.A,
                        defaultSelection: "view._getShiftStatusMethod"
                    },
                    events: {
                        "change": "_onShiftStatusMethodChange"
                    }
                },
                scheduledSchedulePicker: {
                    type: SchedulePicker,
                    options: {
                        container: "view.ui.scheduledSchedulePickerComponent",
                        model: "view._getScheduledSelectedSchedule"
                    },
                    events: {
                        "edit": "_triggerScheduledEditSchedule"
                    }
                },
                scheduledSpecialOccasionPicker: {
                    type: SpecialOccasionPicker,
                    options: {
                        container: "view.ui.scheduledSpecialOccasionPickerComponent",
                        model: "view._getScheduledSelectedSpecialOccasion"
                    },
                    events: {
                        "edit": "_triggerScheduledEditSpecialOccasion"
                    }
                },
                manualStatusList: {
                    type: RadioButtonList,
                    options: {
                        el: "view.ui.manualStatusList",
                        items: [
                            {key: MANUAL_STATUSES.ONLINE, label: LE.translator.translate("LEManager.manager.shift.status.list.online")},
                            {key: MANUAL_STATUSES.OFF_HOURS, label: LE.translator.translate("LEManager.manager.shift.status.list.off.hours")}
                        ],
                        allowHtml: false,
                        permutation: RadioButtonList.PERMUTATION.A,
                        defaultSelection: "view._getManualStatus"
                    },
                    events: {
                        "change": "_triggerManualConfigurationChange"
                    }
                },
                manualDatePicker: {
                    type: DatePicker,
                    options: {
                        el: "view.ui.manualDatePicker",
                        selectedDate: "view._getManualSelectedDate",
                        minDate: "view._getManualMinDate"
                    },
                    events: {
                        "dateselected": "_triggerManualConfigurationChange"
                    }
                },
                manualHoursList: {
                    type: Dropdown,
                    options: {
                        container: "view.ui.manualHoursList",
                        permutation: Dropdown.PERMUTATION.X_SMALL,
                        items: "view._getManualHoursOptions",
                        selectedOption: "view._getManualSelectedHour"
                    }  ,
                    events: {
                        "change": "_triggerManualConfigurationChange"
                    }
                },
                manualLinkToVisitors: {
                    type: Button,
                    options: {
                        el: "view.ui.manualErrorLinkToVisitors",
                        permutation: Button.PERMUTATION.BLUELINK
                    },
                    events: {
                        "click": "_onLinkToVisitorsClick"
                    }
                },
                btnCancel: {
                    type: Button,
                    options: {
                        el: "view.ui.btnCancel",
                        permutation:Button.PERMUTATION.LINK
                    },
                    events : {
                        click : "_onCancelButtonClick"
                    }
                },
                btnSave: {
                    type: Button,
                    options: {
                        el: "view.ui.btnSave",
                        permutation: Button.PERMUTATION.BTN_PRIMARY
                    },
                    events : {
                        click : "_onSaveButtonClick"
                    }
                }
            },

            initialize: function(options) {
                this._initialize(options);
            },
            onRender: function() {
                this._onRender();
            },
            updateManualData: function(manualData) {
                this._updateManualData(manualData);
            },
            showWebsocketError: function() {
                this._showWebsocketError();
            },


            _initialize: function(options) {
                options = options || {};
                this.channel = LEManager.media.channel(LE.mediaCodes.manager.channels.SHIFT_STATUS);
                this.isManual = options.isManual;
                this.scheduledData = options.scheduledData;
                this.manualData = options.manualData;
            },

            _onRender: function() {
                this._showRelevantConfiguration();
                this._showManualNextShiftConfig();
                this.listenTo(this, "page:closeButtonClick", this._onCancelButtonClick);
            },

            _showRelevantConfiguration: function() {
                this.ui.manualConfiguration.toggleClass("hide", !this.isManual);
                this.ui.scheduledConfiguration.toggleClass("hide", this.isManual);

                if (!this.isManual) {
                    var isScheduledFeatureEnabled = LEConfig.scheduledWorkingHours;
                    this.ui.scheduledConfigurationAvailable.toggleClass("hide", !isScheduledFeatureEnabled);
                    this.ui.scheduledConfigurationComingSoon.toggleClass("hide", isScheduledFeatureEnabled);
                    this.uiComponents.btnSave.setEnabled(isScheduledFeatureEnabled);
                }
                else {
                    this.uiComponents.btnSave.setEnabled(true);
                }

                var showNoScheduleSelected = _.isEmpty(this._getScheduledSelectedSchedule());
                this.ui.scheduledScheduleNoSelectionNote.toggleClass("hide", !showNoScheduleSelected);
            },

            _showManualNextShiftConfig: function() {
                var showNextShiftConfiguration = this.isManual && (this._getManualStatus() === MANUAL_STATUSES.OFF_HOURS);
                this.ui.manualNextShiftOverlay.toggleClass("hide", showNextShiftConfiguration);

                var dataExists = !_.isEmpty(this.manualData);
                this.ui.manualNextShiftConfig.toggleClass("hide", !dataExists);
                this.ui.manualStatusList.toggleClass("hide", !dataExists);
                this.ui.manualErrorContainer.toggleClass("hide", dataExists);
                if (!dataExists) {
                    var loader = new Loader({
                        permutation: Loader.PERMUTATION.H,
                        el: this.ui.manualLoadingLabel.find(".loader-container")
                    });
                    loader.render();
                }
            },

            _onShiftStatusMethodChange: function(componentId, eventName, value) {
                this.isManual = (value === SHIFT_STATUS_METHODS.MANUAL);
                this.channel.trigger("ShiftStatusView:change:shiftStatusMethod", this.isManual);

                this._showRelevantConfiguration();
            },

            _getShiftStatusMethod: function() {
                return this.isManual ? SHIFT_STATUS_METHODS.MANUAL : SHIFT_STATUS_METHODS.SCHEDULED;
            },

            _triggerManualConfigurationChange: function(componentId, eventName, value) {
                var configuration = {
                    isOnline: this.uiComponents.manualStatusList.getSelectedKey() === MANUAL_STATUSES.ONLINE,
                    selectedDate: this.uiComponents.manualDatePicker.getSelectedDate(),
                    selectedHour: this.uiComponents.manualHoursList.getValue()
                };

                this.channel.trigger("ShiftStatusView:change:manualConfiguration", configuration);
            },

            _triggerScheduledEditSchedule: function (){
                this.channel.trigger("ShiftStatusView:open:scheduleGallery");
            },

            _triggerScheduledEditSpecialOccasion: function (){
                this.channel.trigger("ShiftStatusView:open:specialOccasionGallery");
            },

            _updateManualData: function(manualData) {
                this.manualData = manualData;
                this.uiComponents.manualStatusList.setSelection(this._getManualStatus());
                this.uiComponents.manualDatePicker.setSelectedDate(this._getManualSelectedDate());
                this.uiComponents.manualHoursList.setSelection(this._getManualSelectedHour());
                this._showManualNextShiftConfig();
            },

            _getScheduledSelectedSchedule: function() {
                return this.scheduledData.selectedScheduleModel;
            },

            _getScheduledSelectedSpecialOccasion: function() {
                return this.scheduledData.selectedSpecialOccasionModel;
            },

            _getManualStatus: function() {
                var isOnline = true;
                if (this.manualData && this.manualData.delay) {
                    var now = new Date();
                    var tillWhen = this.manualData.delay.tillWhen;
                    if (tillWhen) {
                        isOnline = now.getTime() >= tillWhen;
                    }
                }

                return (isOnline) ? MANUAL_STATUSES.ONLINE : MANUAL_STATUSES.OFF_HOURS;
            },

            _getManualSelectedDate: function() {
                var date = new Date();
                date.setDate(date.getDate() + 1);

                if (this.manualData && this._getManualStatus() === MANUAL_STATUSES.OFF_HOURS) {
                    date = new Date(this.manualData.delay.tillWhen);
                }

                return date;
            },

            _getManualMinDate: function() {
                return new Date();
            },

            _getManualSelectedHour: function() {
                var selectedHour = "09:00:00";
                if (this._getManualStatus() === MANUAL_STATUSES.OFF_HOURS) {
                    var date = this._getManualSelectedDate();
                    var hour = date.getHours();
                    if (hour < 10) {
                        hour = "0" + hour;
                    }
                    var minutes = date.getMinutes();
                    if (minutes < 10) {
                        minutes = "0" + minutes;
                    }
                    selectedHour = hour + ":" + minutes + ":00";
                }
                return selectedHour;
            },

            _getManualHoursOptions: function() {
                var items = [];
                for (var number=0; number<24; number++){
                    var keyHour = (number > 9) ? number.toString() : "0" + number.toString();
                    var keyHalfHour = keyHour + ":30:00";
                    keyHour = keyHour + ":00:00";
                    var ampmString = number < 12 ? LE.translator.translate("LEFramework.timeFrame.period.am") : LE.translator.translate("LEFramework.timeFrame.period.pm");
                    var valueHour;
                    var valueHalfHour;
                    if (number === 0) {
                        valueHour = "12:00 " + ampmString;
                        valueHalfHour = "12:30 " + ampmString;
                    }
                    else if (number <= 12) {
                        valueHour = number + ":00 " + ampmString;
                        valueHalfHour = number + ":30 " + ampmString;
                    }
                    else {
                        valueHour = (number - 12) + ":00 " +ampmString;
                        valueHalfHour = (number - 12) + ":30 " +ampmString;
                    }
                    items.push({key: keyHour, value:valueHour});
                    items.push({key:keyHalfHour, value:valueHalfHour});
                }
                return new Dropdown.Collection(items);
            },

            _showWebsocketError: function() {
                if (this.ui.manualErrorLabel && _.isFunction(this.ui.manualErrorLabel.removeClass)) {
                    this.ui.manualErrorLabel.removeClass("hide");
                    this.ui.manualLoadingLabel.addClass("hide");
                }
            },

            _onLinkToVisitorsClick: function() {
                this.channel.trigger("ShiftStatusView:goToVisitors");
            },

            _onCancelButtonClick: function() {
                this.channel.trigger("ShiftStatusView:cancel");
            },

            _onSaveButtonClick: function() {
                this.channel.trigger("ShiftStatusView:save");
            }
        });

        ShiftStatusView.TRIGGERING = {
            SAVE_BUTTON_CLICKED: "shiftStatus:saveButtonClicked",
            CANCEL_BUTTON_CLICKED: "shiftStatus:cancelButtonClicked"
        };
    });

    return ShiftStatusView;
});
